export default __webpack_public_path__ + "static/principle2-c6a364de7df058f22e59d976cf4c766674914aac6daa53f73570b87a31b5ee72.png";